<div [ngClass]="{'container': !isWorkload()}">
  <ng-container *ngIf="isWorkload(); then workloadCT; else nonWorkLoad">
  </ng-container>
</div>

<ng-template #workloadCT>
  <h2 class="backlog-setting">
    {{"plan.ct.settings.workload.group.title" | translate}}
  </h2>
  <div class="col-16 user-field">
    <div class="row">
      <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
        <label id="startingBacklogLabel" class="text-uppercase input-label">
          {{"plan.settings.ct.dlg.starting.backlog" | translate}}
        </label>
      </div>
    </div>
    <div class="row">
      <div class='col-sm-12'>
        <div>
          <form [formGroup]="backlogForm">
            <p-inputnumber
              mode="decimal"
              [useGrouping]="false"
              name="startingBacklogInput"
              inputId="startingBacklogInput"
              autocomplete="off"
              formControlName="backlogInput"
              [size]="9"
              [required]="true"
              [min]="0"
              [ariaLabelledBy]="'startingBacklogLabel'"
              [ariaDescribedBy]="invalidBacklogInput ? 'startingBacklogUnit startingBacklogError' : 'startingBacklogUnit'"
              (onInput)="onInput($event)"
            >
            </p-inputnumber> <span id="startingBacklogUnit">{{"plan.settings.ct.dlg.contacts" | translate}}</span>
            <div id="startingBacklogError" role="alert" aria-live="assertive" aria-atomic="true">
              <div *ngIf="invalidBacklogInput" class="error-message">{{'plan.settings.ct.dlg.contacts.validation'|translate}}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #nonWorkLoad>
  <div class="non-workload">
    <wfm-esp-no-rows-overlay [params]="params"></wfm-esp-no-rows-overlay>
  </div>
</ng-template>
